export default function isArraysJoint(arr1:string[], arr2:string[]):boolean {
    return !!arr1?.filter(a1 => arr2?.includes(a1)).length
}